"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _lodash = require("lodash");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _CustomSelect = _interopRequireDefault(require("./CustomSelect"));
var _CustomRadioGroup = _interopRequireDefault(require("./CustomRadioGroup"));
var _CustomTextField = _interopRequireDefault(require("./CustomTextField"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    centerText: {
      textAlign: 'center'
    }
  };
};
var CustomVendorProductSelect = /*#__PURE__*/function (_Component) {
  function CustomVendorProductSelect(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CustomVendorProductSelect);
    _this = _callSuper(this, CustomVendorProductSelect, [props]);
    //Convert the string value into an array of arrays representing the rows
    var rows = props.value ? props.value.map(function (v, index) {
      var vp = JSON.parse(v);
      var installationID = vp.installationID;
      var vendor = (0, _lodash.find)(props.vendorsList, {
        value: vp.vendorID
      });
      var product = (0, _lodash.find)(props.productsList, {
        value: vp.productID
      });
      var otherVendor = vp.otherVendor;
      var otherProduct = vp.otherProduct;
      return {
        id: index,
        installationID: installationID ? installationID : '',
        vendor: vendor ? vendor : '',
        product: product ? product : '',
        otherVendor: otherVendor ? otherVendor : '',
        otherProduct: otherProduct ? otherProduct : ''
      };
    }) : [];
    if (rows.length === 0) {
      rows.push({
        id: rows.length,
        vendor: '',
        product: '',
        otherVendor: '',
        otherProduct: '',
        installationID: ''
      });
    }
    _this.state = {
      rows: rows
    };
    ['addRow', 'updateRow', 'deleteRow', 'convertToValue'].map(function (item) {
      return _this[item] = _this[item].bind(_this);
    });
    return _this;
  }
  (0, _inherits2["default"])(CustomVendorProductSelect, _Component);
  return (0, _createClass2["default"])(CustomVendorProductSelect, [{
    key: "addRow",
    value: function addRow() {
      var rows = [].concat(this.state.rows);
      rows.push({
        id: rows.length,
        vendor: '',
        product: '',
        otherVendor: '',
        otherProduct: '',
        installationID: ''
      });
      this.setState({
        rows: rows
      });
    }
  }, {
    key: "deleteRow",
    value: function deleteRow(id) {
      var rows = [].concat(this.state.rows);
      var idx = rows.findIndex(function (r) {
        return r.id === id;
      });
      rows.splice(idx, 1);
      this.setState({
        rows: rows
      });

      //Convert the rows array into a string value that can be saved off to the survey
      this.props.onChange(this.convertToValue(rows));
    }
  }, {
    key: "updateText",
    value: function updateText(id, field) {
      var _this2 = this;
      return function (value) {
        var rows = [].concat(_this2.state.rows);
        var idx = rows.findIndex(function (r) {
          return r.id === id;
        });
        rows[idx][field] = value.target.value;
        _this2.setState({
          rows: rows
        });

        //Convert the rows array into a string value that can be saved off to the survey
        _this2.props.onChange(_this2.convertToValue(rows));
      };
    }
  }, {
    key: "updateRow",
    value: function updateRow(id, field) {
      var _this3 = this;
      return function (event, value) {
        var rows = [].concat(_this3.state.rows);
        var idx = rows.findIndex(function (r) {
          return r.id === id;
        });
        rows[idx][field] = value;
        _this3.setState({
          rows: rows
        });
        _this3.props.onChange(_this3.convertToValue(rows));
      };
    }
  }, {
    key: "convertToValue",
    value: function convertToValue(rows) {
      //Convert to array or arrays for simplicity when saving the surey values
      var value = rows.map(function (r) {
        return JSON.stringify({
          vendorID: r.vendor.value,
          productID: r.product.value,
          otherVendor: r.otherVendor,
          otherProduct: r.otherProduct,
          installationID: r.installationID
        });
      });
      return value;
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var _this$props = this.props,
        classes = _this$props.classes,
        vendorsList = _this$props.vendorsList,
        productsList = _this$props.productsList;
      var rows = this.state.rows;
      var blankOption = [{
        label: '',
        value: ''
      }];
      vendorsList = (0, _lodash.sortBy)(vendorsList, ['label']);
      productsList = (0, _lodash.sortBy)(productsList, ['label']);

      //Filter the list of vendors based on the current tab technologyId and the countryID of the entity.
      var countryID = this.props.entity ? this.props.entity.countryID : null; /* 248 United States */
      var filteredVendorsList = (0, _lodash.filter)(vendorsList, function (v) {
        var matchesTech = v.technologies.length === 0 || v.technologies.includes(_this4.props.technologyId);
        var matchesCountry = !countryID || v.countries.includes(countryID);
        return matchesTech && matchesCountry;
      });

      //Filter the list of products based on the current tab technologyId and the countryID of the entity.
      var filteredProductsList = (0, _lodash.filter)(productsList, function (p) {
        var matchesTech = p.technologies.length === 0 || p.technologies.includes(_this4.props.technologyId);
        var matchesCountry = !countryID || p.countries.includes(countryID);
        return matchesTech && matchesCountry;
      });
      var distinctProducts = [];
      var map = new Map();
      var _iterator = _createForOfIteratorHelper(productsList),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          if (!map.has(item.value)) {
            map.set(item.value, true); // set value to Map
            distinctProducts.push({
              vendorID: item.vendorID,
              technologies: item.technologies,
              countries: item.countries,
              value: item.value,
              label: item.label
            });
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return /*#__PURE__*/_react["default"].createElement(_material.Table, null, /*#__PURE__*/_react["default"].createElement("colgroup", null, /*#__PURE__*/_react["default"].createElement("col", {
        style: {
          width: '50%'
        }
      }), /*#__PURE__*/_react["default"].createElement("col", {
        style: {
          width: '50%'
        }
      })), /*#__PURE__*/_react["default"].createElement(_material.TableHead, null, /*#__PURE__*/_react["default"].createElement(_material.TableRow, {
        style: {
          backgroundColor: '#fafafa'
        }
      }, /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
        className: classes.centerText
      }, "Vendor"), /*#__PURE__*/_react["default"].createElement(_material.TableCell, {
        className: classes.centerText
      }, "Product"), /*#__PURE__*/_react["default"].createElement(_material.TableCell, null, this.props.allowMultiple && /*#__PURE__*/_react["default"].createElement(_material.Button, {
        variant: "contained",
        color: "primary",
        className: classes.button,
        onClick: function onClick() {
          return _this4.addRow();
        }
      }, "Add")))), /*#__PURE__*/_react["default"].createElement(_material.TableBody, null, rows.map(function (r) {
        var vendorProductsList = r.vendor ? (0, _lodash.filter)(filteredProductsList, function (p) {
          return p.vendorID === r.vendor.value;
        }) : distinctProducts;
        return /*#__PURE__*/_react["default"].createElement(_material.TableRow, {
          key: r.id
        }, /*#__PURE__*/_react["default"].createElement(_material.TableCell, null, /*#__PURE__*/_react["default"].createElement(_CustomSelect["default"], {
          name: "vendor",
          value: r.vendor,
          onChange: function onChange(value) {
            return _this4.updateRow(r.id, 'vendor', value);
          },
          options: blankOption.concat(filteredVendorsList),
          isMulti: false,
          label: ""
        }), r.vendor.value == '5791' && /*#__PURE__*/_react["default"].createElement(_CustomTextField["default"], {
          className: classes.textField,
          key: "otherVendor",
          margin: "dense",
          name: "othervendor",
          defaultValue: r.otherVendor,
          onBlur: _this4.updateText(r.id, 'otherVendor')
        })), /*#__PURE__*/_react["default"].createElement(_material.TableCell, null, /*#__PURE__*/_react["default"].createElement(_CustomSelect["default"], {
          name: "product",
          value: r.product,
          onChange: function onChange(value) {
            return _this4.updateRow(r.id, 'product', value);
          },
          options: blankOption.concat(vendorProductsList),
          isMulti: false,
          label: ""
        }), r.product.value == '6294' && /*#__PURE__*/_react["default"].createElement(_CustomTextField["default"], {
          className: classes.textField,
          key: "otherProduct",
          margin: "dense",
          name: "otherproduct",
          defaultValue: r.otherProduct,
          onBlur: _this4.updateText(r.id, 'otherProduct')
        })), /*#__PURE__*/_react["default"].createElement(_material.TableCell, null, _this4.props.allowMultiple && /*#__PURE__*/_react["default"].createElement(_material.Button, {
          color: "primary",
          className: classes.button,
          onClick: function onClick() {
            return _this4.deleteRow(r.id);
          }
        }, "Delete")));
      })));
    }
  }]);
}(_react.Component);
CustomVendorProductSelect.propTypes = {
  value: _propTypes["default"].array,
  onChange: _propTypes["default"].func.isRequired,
  previousValue: _propTypes["default"].string,
  vendorsList: _propTypes["default"].array.isRequired,
  productsList: _propTypes["default"].array.isRequired,
  technologyId: _propTypes["default"].number.isRequired,
  allowMultiple: _propTypes["default"].bool.isRequired
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(CustomVendorProductSelect);